module.exports = __webpack_public_path__ + "static/media/swimmy-twitter-600x314.82eef450.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swimmy-twitter-600x314.jpg
// module id = 854
// module chunks = 0